import { CommonElementType } from "@utils/DynamicComponentUtils";
import { type CommonContentsRenderType, type CommonCreateBodyKeyType, type CommonDataType } from "src/types/common";

export type AppVersionDetailInitValuesType = {
    platform: string;
    versionName: string;
    releaseNotes: string;
    isForceUpdate: string;
};

export type AppVersionCreateContentsOptionType = {
    placeholder?: string;
    textAreaRows?: number;
} & CommonContentsRenderType;

export const AppVersionDetailData: CommonDataType<CommonCreateBodyKeyType, AppVersionDetailInitValuesType, AppVersionCreateContentsOptionType> = {
    createBodyKey: ["platform", "versionName", "releaseNotes", "isForceUpdate"],
    formInitialValues: {
        platform: "",
        versionName: "",
        releaseNotes: "",
        isForceUpdate: "",
    },
    contentsOption: [
        {
            type: CommonElementType.INFO_INPUT,
            name: "platform",
            label: "OS",
        },
        {
            label: "강제 업데이트",
            name: "isForceUpdate",
            type: CommonElementType.INFO_INPUT,
        },
        {
            type: CommonElementType.INFO_INPUT,
            name: "versionName",
            label: "버전",
        },
    ],
    secondContentsOption: [
        {
            label: "릴리즈 노트(선택)",
            name: "releaseNotes",
            type: CommonElementType.TEXTAREA,
            placeholder: "릴리즈 노트를 입력해주세요",
            textAreaRows: 4,
        },
    ],
};
